export default "__VITE_ASSET__wwMmB2MA__"